import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories } from '@zendra/shared';
// TODO: Import required services for Foreign Keys
import { ActivityProcessParametrizationService } from '../proxy/controlling/controllers/activity-process-parametrization.service';
import { LevelService } from '../proxy/controlling/controllers/level.service';
import { ActivityToolService } from '../proxy/controlling/controllers/activity-tool.service';
import { ActivityReasonService } from '../proxy/controlling/controllers/activity-reason.service';
import { WbsService } from '../proxy/controlling/controllers/wbs.service';
import { LocationTypePerActivity } from '@controlling/location-type-per-activity/location-type-per-activity';
import { WorkTypeService } from '@general/proxy/general/controllers/work-type.service';

FieldBuilder.setNamespace('Controlling');

export const PATRIMONYACTIVITYPARAMETER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('mustHavePrice', 'Entity.PatrimonyActivityParameter.MustHavePrice')
    .build(),
  FieldBuilder
    .checkbox('isCalculated', 'Entity.PatrimonyActivityParameter.IsCalculated')
    .build(),
  FieldBuilder
    .text('projectOrder', 'Entity.PatrimonyActivityParameter.ProjectOrder')
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .checkbox('isVisible', 'Entity.PatrimonyActivityParameter.IsVisible')
    .build(),
  FieldBuilder
    .foreignKey('activityProcessParametrizationId', 'Entity.ActivityProcessParametrization', ActivityProcessParametrizationService)
    .required()
    .display('name')
    .keyField('id')
    .hideInChildForms()
    .build(),
  FieldBuilder
    .foreignKey('levelId', 'Entity.Level', LevelService)
    .displayFromNested('level.name')
    .sortBy('level.name')
    .build(),
  FieldBuilder
    .foreignKey('activityToolId', 'Entity.ActivityTool', ActivityToolService)
    .displayFromNested('activityTool.name')
    .sortBy('activityTool.name')
    .build(),
  FieldBuilder
    .foreignKey('activityReasonId', 'Entity.ActivityReason', ActivityReasonService)
    .displayFromNested('activityReason.name')
    .sortBy('activityReason.name') 
    .build(),
  FieldBuilder
    .foreignKey('wbsId', 'Entity.Wbs', WbsService)
    .displayFromNested('wbs.name') 
    .sortBy('wbs.name')
    .build(),
 FieldBuilder
   .foreignKey('workTypeId', 'Entity.WorkType', WorkTypeService)
   .display('name')
   .keyField('id')
   .build(),
];

export const PATRIMONYACTIVITYPARAMETER_CONFIG = {
  entityName: 'PatrimonyActivityParameter',
  localizationKey: 'Controlling::Entity.PatrimonyActivityParameter',
  fields: PATRIMONYACTIVITYPARAMETER_FIELDS,
  permission: 'ControllingActivities.PatrimonyActivityParameters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
  children: [
      {
        entityName: 'LocationTypePerActivity',
        foreignKeyField: 'patrimonyActivityParameterId',
        localizationKey: 'Controlling::Entity.LocationTypePerActivity',
        component: LocationTypePerActivity,
      },
    ]
};
